import api from "src/api/index";

export  async function getProductHints(name) {
  if (!name?.trim()) {
    return
  }
  const hintsForm = new FormData()
  hintsForm.append("name", name)
  return await api.post("hints-products", hintsForm)
}